import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import { RequestService } from '../../../../services/request/request.service';
import { AlertBannerService, AlertType } from "../../../../lib/alert-banner";
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { BsModalRef } from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { environment } from '../../../../../environments/environment';
import * as Cookies from "js-cookie";

@Component({
  selector: 'app-select-background-check-modal',
  templateUrl: './select-background-check-modal.component.pug',
  styleUrls: ['./select-background-check-modal.component.scss'],
  standalone: false
})
export class SelectBackgroundCheckModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter();
  totalChecks: any;
  backgroundCheck!: any;
  @Input() backgroundChecks: any = [];
  @Input() backgroundChecksData: any = {};
  @Input() flow: any = {};
  @Input() flows: any[] = [];
  searchTitle = $localize`Background checks will appear here`;
  searchImg = ConstantsService.searchImg
  noSearchResultTitle = ConstantsService.searchTitle;
  noSearchDescription = ConstantsService.searchDescription;
  searchDescription = $localize`Background checks made available through Trust Marketplace will appear here.`;
  searchDescriptionNoPermission = $localize`Background checks made available through Trust Marketplace will appear here. Contact your background check administrator to complete setup within Trust Marketplace.`;
  createBtn = $localize`Go to Trust Marketplace`
  canManageBCG = false
  sortCriteria = {
    sortString: 'name',
    sortOrder: 'asc',
    sortOptions: [
      {
        'label': $localize`Check name`,
        'type': "word",
        'value': "name"
      },
      {
        'label': $localize`Vendor`,
        'type': "word",
        'value': "provider"
      },
      {
        'label': $localize`Check type`,
        'type': "word",
        'value': "type"
      }
    ]
  }
  pagination = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  }
  searchLabels = this.sortCriteria['sortOptions'].map(each => each.label);
  searchOptions = [
    {
      'label': $localize`Check name`,
      'hint': $localize`Check name`,
      'value': "name"
    },
    {
      'label': $localize`Vendor`,
      'hint': $localize`Vendor name`,
      'value': "provider"
    },
    {
      'label': $localize`Check type`,
      'hint': $localize`Check type`,
      'value': "type"
    }
  ];
  searchTags: any[] = [];
  searchValue = "";
  filters: any = {};
  backgroundCheckList: any;
  mobileIdFlows = [ ConstantsService.ID_ONE_DOC_SHORT_NAME, ConstantsService.ID_TWO_DOCS_SHORT_NAME, ConstantsService.ID_ONE_DOC_DVS_SHORT_NAME, ConstantsService.ID_TWO_DOCS_DVS_SHORT_NAME ];
  categorizedBackgroundChecks: any[] = [];
  trustUrl: string = environment.TRUST_MARKETPLACE_URL;
  languageLocal = Cookies.get(ConstantsService.XREF_LOCALE)?.toUpperCase();

  constructor(public _bsModalRef: BsModalRef, private requestService: RequestService,
    private alertList: AlertBannerService, private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {

    this.canManageBCG = this.permissionsService.hasPermission("can_use_link_to_trust")
    this.backgroundCheckList = this.backgroundChecksData['backgroundChecks'];
    this.pagination.total = this.backgroundChecksData['pagination'].total;
    this.totalChecks = this.backgroundChecksData['totalChecks'];
    this.categorizedBackgroundChecks = this.backgroundChecksData['categorizedChecks'];
  }

  onSearchChange(event) {
    if (event.label === 'all') {
      this.createTagNew('All', event.term, 'all');
    } else {
      this.createTagNew(event.label, event.term, event.value);
    }
    this.searchValue = event.term;
    this.getBackgroundChecksList();
  }

  createTagNew(label, value, param) {
    this.searchTags = [...this.searchTags, { label: label, value: value, param: param }];
  }

  closeTag(tagIndex) {
    const updatedSearchTags = [...this.searchTags];
    updatedSearchTags.splice(tagIndex, 1);
    this.searchTags = updatedSearchTags;
    this.getBackgroundChecksList();
  }

  clearTags() {
    this.searchTags = [];
    this.getBackgroundChecksList();
  }

  onSortChange(sortString: string): void {
    this.sortCriteria.sortString = sortString;
    this.getBackgroundChecksList();
  }

  cancel() {
    this._bsModalRef.hide();
  }

  selectedBackgroundCheck(data: any) {
    this.backgroundCheck = data;
  }

  selectBackgroundCheck() {
    this.nextClick.emit({ backgroundCheck: this.backgroundCheck, flow: this.flow })
    this._bsModalRef.hide();
  }

  selectedBackgroundChecks(data: any) {
    this.backgroundChecks = data;
  }

  selectBackgroundChecks() {
    this.nextClick.emit({ backgroundCheck: this.backgroundChecks, flows: this.flows })
    this._bsModalRef.hide();
  }

  selectedflow(data: any) {
    this.flows = data;
  }

  onPageChange(pageNumber) {
    this.pagination.currentPage = pageNumber;
    this.getBackgroundChecksList();
  }

  onPageSizeChange(rowsPerView) {
    this.pagination.rowsPerView = rowsPerView;
    this.pagination.currentPage = 1;
    this.getBackgroundChecksList();
  }

  applyFilters(filters) {
    this.filters['check_types'] = filters.selected_check_types?.map(item => item.name).join(',');
    this.filters['regions'] = filters.selected_regions?.map(item => item.name).join(',');
    this.getBackgroundChecksList();
  }

  getBackgroundChecksList() {
    this.requestService.getEnhancedBackgroundChecksList(this.searchTags, this.pagination.rowsPerView, this.pagination.currentPage, this.sortCriteria.sortString, this.filters).subscribe(response => {
      this.backgroundCheckList = this.checksVisibleForTrust1337(response['data']['background_checks']);
      this.pagination.total = response['data']['total_background_checks'];
      this.totalChecks = response['data']['total_background_checks'];
      this.categotizeCheckNamesByFlow();
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      });

  }

  private checksVisibleForTrust1337(checks: any[] = []) {
    return (checks || []).filter(check => {
      if (check.short_name === ConstantsService.AU_ENHANCED_PUBLIC_RECORD_CHECK_SHORT_NAME) {
        return this.permissionsService.isFeatureActivated('trust-1337-directorship-credit-checks');
      }
      if (check.short_name === ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME) {
        return this.permissionsService.isFeatureActivated('trust-1337-directorship-credit-checks');
      }
      return true;
    });
  }

  // Categorise ID checks into flow names making MobileID the parent check
  categotizeCheckNamesByFlow() {
    // reset categorizedBackgroundChecks each time the function is called
    this.categorizedBackgroundChecks = [];

    if (this.totalChecks > 0) {
      const mobileIdCheck = {
        "uid": "12345",
        "short_name": "mobile_id",
        "name": "MobileID",
        "provider_name": "RapidID",
        "config": {}
      };
      let matchedFlows: any[] = [];
      let isAdded = false;
      let insertionIndex = -1;
      let uniqueRegions = new Set<string>();
      let uniqueCategories = new Set<string>();
      this.backgroundCheckList.forEach(check => {
        if (this.mobileIdFlows.includes(check.short_name)) {
          if(!isAdded){
            // Add MobileID check in the position of ID check to maintain sort order and record the index
            insertionIndex = this.categorizedBackgroundChecks?.length;
            this.categorizedBackgroundChecks.push(mobileIdCheck);
            isAdded = true;
          }
          matchedFlows.push(check);
          // Combine unique regions and categories of each id flow
          check.config.regions.forEach(region => uniqueRegions.add(region));
          check.config.categories.forEach(category => uniqueCategories.add(category));
        } else {
            check['flow_names'] = check.config.flows
            this.categorizedBackgroundChecks.push(check);
        }
      });
      // If there are any id checks, add them under flow_names in MobileID
      if (matchedFlows?.length > 0 && insertionIndex != -1) {
        this.categorizedBackgroundChecks[insertionIndex]['flow_names'] = matchedFlows;
        this.categorizedBackgroundChecks[insertionIndex]['config']['regions'] = Array.from(uniqueRegions);
        this.categorizedBackgroundChecks[insertionIndex]['config']['categories'] = Array.from(uniqueCategories);
      }
    }
  }

  connectBCG(){
      // no need to check trust admin status or trust status. only allowed user to select BCG when trust admin status
      // is conected & trust is also connected
      let urlToOpen = this.trustUrl + this.languageLocal;
      window.open(urlToOpen);
  }
}
